import React from 'react';

const ModalScreenManager = ({ isVisible, onClose, videoDati }) => {

    const handleClose = (e) => {
        if (e.target.id === "wrapper") onClose();
    }
    //console.log(`http://localhost/F:/GIT/ScreenAlta/${videoDati.firstDirName}/${videoDati.fileName}`);

    //videoDati.firstDirName = videoDati.firstDirName === "" ? videoDati.firstDirName : videoDati.firstDirName.replaceAll('{-}', '/') 

    function greaterThanZero(value) {
        if (value < 10) {
            return `0${value}`
        } else {
            return value
        }
    }

    if (!isVisible) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 p-4 backdrop-blur-sm" id="wrapper" onClick={handleClose}>
            <div className="max-h-[90vh] w-full max-w-5xl overflow-y-auto rounded-2xl bg-white shadow-2xl">
                <div className="flex items-center justify-between border-b border-slate-200 px-6 py-4">
                    <h2 className="text-lg font-semibold text-slate-800">Aperçu de l'écran</h2>
                    <button className="text-slate-400 hover:text-slate-600" onClick={() => onClose()}>✕</button>
                </div>
                <div className="flex flex-col gap-6 p-6 md:flex-row">

                    <div className="m-auto" id='videoDiv'>
                        {/* <video key={videoDati.fileName} width="750" autoPlay muted controls preload="auto" id="videoUrl" >
                            <source src={videoDati.firstDirName ? `${process.env.REACT_APP_DL_IP}${videoDati.firstDirName}/${videoDati.fileName}` : `${process.env.REACT_APP_DL_IP}${videoDati.fileName}`} type="video/mp4" />
                        </video> */}
                        <img src={`${process.env.REACT_APP_DL_IP}ScreenAlta/${videoDati.firstDirName}/${videoDati.fileName}`} alt="Screen" width="800" height="900" className="max-w-full rounded-lg" />

                    </div>
                    <div className="w-full rounded-2xl border border-slate-200 bg-slate-50 p-6 md:w-1/4">
                        <h4 className="mb-2 text-sm text-slate-600"><span className="font-semibold text-slate-800">Nom :</span> {videoDati.fileName}</h4>
                        <h4 className="mb-2 text-sm text-slate-600"><span className="font-semibold text-slate-800">Taille :</span> {videoDati.fileSize}</h4>
                        <h4 className="text-sm text-slate-600"><span className="font-semibold text-slate-800">Date :</span> {greaterThanZero(new Date(videoDati.fileDate).getUTCDate())}/{greaterThanZero(new Date(videoDati.fileDate).getUTCMonth())}/{greaterThanZero(new Date(videoDati.fileDate).getUTCFullYear())}  {greaterThanZero(new Date(videoDati.fileDate).getUTCHours() + 2)}:{greaterThanZero(new Date(videoDati.fileDate).getUTCMinutes())}</h4>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalScreenManager;